import {featureFlagKeys as FEATURE_FLAG_KEYS} from './feature-flag-keys';

/**
 *
 * @depends $q
 * @depends manager.api.FeatureFlagApi
 *
 */

export const FeatureFlagsService = function FeatureFlagsService(
    $q,
    FeatureFlagApi,
    $http,
    SessionStorageCacheService,
    $window,
    LoggingApi
) {
    const service = this;

    // feature flag keys defined in LaunchDarkly
    service.keys = FEATURE_FLAG_KEYS;

    service.retrieveFlag = function retrieveFlag(featureFlagKey) {
        if (featureFlagKey === undefined) {
            const errorMessage = 'No feature flag found.';
            const jsErrorDto = {
                message: errorMessage,
                location: $window.location.pathname,
                userAgent: $window.navigator.userAgent
            };
            LoggingApi.logError(jsErrorDto);
            return false;
        }

        return SessionStorageCacheService.retrieve('featureFlags', featureFlagKey, () => {
            return FeatureFlagApi.retrieveFlag({ 'featureFlagKey': featureFlagKey });
        }, 300);  // cache individual feature flag values for 5 minutes
    };

    service.getStickyFlag = function getStickyFlag(featureFlagKey) {
        return FeatureFlagApi.getStickyFlag({ 'featureFlagKey': featureFlagKey });
    };

    service.getRedirectedPage = function getRedirectedPage(destination) {
        return FeatureFlagApi.getRedirectedPage({ requestedUrl: destination })
            .then(response => response && response.RedirectUrl)
            .catch(() => null);
    };
};
FeatureFlagsService.$inject = [
    '$q',
    'FeatureFlagApi',
    '$http',
    'SessionStorageCacheService',
    '$window',
    'LoggingApi'
];
